import React from "react";
import { useNavigate } from "react-router-dom";

const Pagination = ({ totalLists, limit, page, setPage }) => {
  const navigate = useNavigate();

  function switch_router(newPage) {
    navigate(`?page=${newPage}`);
  }

  const totalPages = Math.max(1, Math.ceil(totalLists / limit));

  // ✅ Ép kiểu an toàn
  const currentPage = Number(page) || 1;

  const makePages = () => {
    if (totalPages <= 10) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const nums = new Set([1, totalPages]);
    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) nums.add(i);

    const sorted = Array.from(nums).sort((a, b) => a - b);
    const result = [];

    for (let i = 0; i < sorted.length; i++) {
      result.push(sorted[i]);
      if (i < sorted.length - 1 && sorted[i + 1] > sorted[i] + 1) {
        result.push("ellipsis-" + i);
      }
    }

    return result;
  };

  const pages = makePages();

  if (totalPages <= 1) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-0 justify-center">
      {pages.map((p, idx) =>
        typeof p === "string" ? (
          <span key={p + "-" + idx} className="px-0 py-1 select-none">
            ...
          </span>
        ) : (
          <button
            key={p}
            onClick={() => {
              setPage(p);
              switch_router(p);
            }}
            className={`px-2 py-1 border rounded ${
              currentPage === p ? "bg-blue-500 text-white" : "bg-white"
            }`}
          >
            {p}
          </button>
        )
      )}
    </div>
  );
};

export default Pagination;
